import { useUser } from '../../app/UserContext';
import { useNotifications } from './useNotifications';
import './Notifications.css';

/**
 * A switch, and an explanation only when the switch cannot help.
 *
 * The states that need words are the ones a person has to leave the app to fix:
 * a blocked permission, which only the browser or OS settings can reverse, and
 * iOS in a browser tab, where notifications do not exist until the app is on the
 * Home Screen. Everything else is just on or off.
 */
export function NotificationSettings() {
  const { user } = useUser();
  const { status, isOn, isBusy, canToggle, toggle } = useNotifications(user?.id);

  return (
    <div className="notif-settings">
      <div className="notif-settings__row">
        <span className="notif-settings__label">Notifications</span>
        <button
          type="button"
          role="switch"
          aria-checked={isOn}
          aria-label="Notifications"
          className={`notif-switch ${isOn ? 'notif-switch--on' : ''}`}
          onClick={() => void toggle()}
          disabled={!canToggle || isBusy}
        >
          <span className="notif-switch__knob" />
        </button>
      </div>

      {status === 'denied' && (
        <p className="text-muted">
          Notifications are turned off for SWOL in your browser or phone settings. You&rsquo;ll need
          to turn them back on there first.
        </p>
      )}

      {status === 'needs-install' && (
        <p className="text-muted">
          On iPhone and iPad, add SWOL to your Home Screen first &mdash; tap Share, then{' '}
          <strong>Add to Home Screen</strong>, and open it from there.
        </p>
      )}

      {status === 'unsupported' && (
        <p className="text-muted">This browser doesn&rsquo;t support notifications.</p>
      )}
    </div>
  );
}
